// cartSelectors.js
export const selectCartItems = (state) => state.cart.items;
export const selectTotalItems = (state) => 
  state.cart.items.reduce((sum, item) => sum + (item.quantity || 1), 0);
export const selectTotalPrice = (state) => 
  state.cart.items.reduce((sum, item) => sum + (item.price || item.cost || 0) * (item.quantity || 1), 0);
export const selectIsInCart = (state, id) => 
  state.cart.items.some(item => item.id === id);